module.exports = __webpack_public_path__ + "a9e8cf58.svg";